import { useQuery } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export const getVideosOptions = (sessionId: string) => trpcOptions.app.getVideos.queryOptions({ sessionId })

export function useGetVideos(sessionId: string) {
  return useQuery(getVideosOptions(sessionId))
}
